import { useState, useEffect } from 'react'
import { roundUp } from '../functions/functions'
import useTitle from "../Components/useTitle"
import homeStyles from "../Styles/Home.module.css"
import { Link } from "react-router-dom"
import FlatListItem from "../Components/FlatListItem";

import { db, auth } from '../functions/firebaseFunctions'
import { FaKiss } from 'react-icons/fa'

export default function Home(props) {
  const { setPageName } = props
  useTitle("Home")
  useEffect(() => {
    setPageName("Home")
  }, []);
  const [Err, setErr] = useState(null);
  const [serviceCounts, setServiceCounts] = useState(0);
  const [services, setServices] = useState(null);
  const [actVs, setActVs] = useState(null);

  useEffect(() => {
    getServicesNew();
    getData();
  }, []);

  const getServicesNew = () => {
    //get the list of services
    db.collection('services')
      .get().then(Artists => {
        if (!Artists.empty) {
          //if there are Artist
          let arr = []; //create and empty array
          let countServices = 0;
          Artists.docs.map(Artist => {
            //for each Artist
            let serviceData = Artist.data();
            //get the artist info from the user
            db.collection('users').doc(serviceData.uid)
              .get().then((user) => {
                if (user.exists && user.data()?.mobile_pay_activation) {
                  let userData = user.data();

                  serviceData.services.map(service => {
                    //get data for each service of that artist
                    db.collection('ratings').doc('services').collection(serviceData.uid)
                      .where('type', '==', service.servicetype)
                      .get().then((r) => {
                        let Rqty = 0;
                        let offset = 0;

                        if (!r.empty) {
                          let Rsum = 0;
                          r.docs.map(rat => {
                            let val = rat.data();
                            Rsum = Rsum + val.rating;
                            Rqty = Rqty + 1;

                          });
                          let rat = roundUp(Rsum / Rqty, 0.1);
                          offset = rat / 5;

                        }
                        const photo = userData.photo;
                        const name = userData.name;
                        arr.push({
                          uid: serviceData.uid,
                          type: service.servicetype,
                          price: service.price,
                          name: name,
                          photo: photo,
                          qty: Rqty, offset: offset,
                        }
                        );
                        countServices++;
                        setServiceCounts(countServices);
                        setServices(arr);
                      }).catch(e => { setErr(e); console.log('err', e) });
                  });
                }
              });
          });
        }
      }).catch(e => { setErr(e); console.log('err', e) });;
  };

  const getData = async () => {
    db.collection('venue')
      // .where('owner', '==', auth.currentUser?.uid)
      .get()
      .then((doc) => {
        if (!doc.empty) {
          const vensArr = [];
          let counter = 0;
          let max = doc.docs.length;
          doc.docs.forEach(vens => {
            vensArr.push({ name: vens.data().name, id: vens.data().venueId, docid: vens.data().docid });
            counter++;
            if (counter === max) { 
              setActVs(vensArr);
            }
          });
        }
      }).catch(err => console.log('err', err));
  };

  function shuffleServices() {
    // Создаем копию массива services
    const shuffledServices = [...services];

    // Применяем случайную сортировку
    shuffledServices.sort(() => Math.random() - 0.5);

    return shuffledServices;
  }
  return (
    <section style={{ display: 'flex', flexDirection: 'column', padding: 0, minHeight: '100vh', backgroundColor: 'var(--main)', }}>
      {/* {WW < 510 &&
      <Link to="/" style={{flex: 1, height: 50, alignSelf: 'center'}}>
        <img alt="PartyLiveLogo" src='Logo.png' style={{height: 140, marginBlock: 10}}/>
      </Link>} */}
      {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
      <div className={homeStyles.mainHome} >
        <div className={homeStyles.LogoTextBox}>
          <Link to="/" className={homeStyles.PartyLiveLogo}>
            <img alt="PartyLiveLogo" src='Logo.png' style={{ height: 140, marginBlock: 10 }} />
          </Link>
          <div className={homeStyles.HomePageText}>
            <h1>See Local Parties or Book Your Own</h1>
            <p >PartyLive is the best way for you to book your event and hire your entertainment. Start by creating an event, and get prices from the available services in your area.</p>
          </div>
        </div>
        <div className={homeStyles.showbox} >
          <div className={homeStyles.shoboxColumns} >
            <div id={homeStyles.showboxColumnStop} className={homeStyles.showboxColumn}>
              {services && services.length === serviceCounts ?
                shuffleServices().map(service => 
                  <Link to={`/artist/${service.uid}&${service.type}`} style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', cursor: 'pointer', }}>
                      <FlatListItem key={service.uid + service.type} item={service} type="service"
                    onClick={() => console.log(service)} />
                  </Link>
                  )
                : <p style={{ color: 'white', textAlign: 'center' }}>No Services Posted</p>}
            </div>
            <div id={homeStyles.showboxColumnStop} className={homeStyles.showboxColumnReverse}>
              {actVs ?
                actVs.map(actV => 
                <Link to={`/venue/${actV.id}&${actV.docid}`}>
                  <FlatListItem key={actV.docid} item={actV} type="venue"
                  onClick={() => console.log(actV)} />
                </Link> )
                : <p style={{ color: 'white', textAlign: 'center' }}>No Venues Posted</p>}
            </div>
          </div>
        </div>

      </div>
      <div className={homeStyles.JoinButton}>
        <Link to={auth.currentUser ? '/Profile/register' : '/Profile/dashboard'} id={homeStyles.JoinButton} className='btnYorp' >
          <p style={{ fontWeight: 'bolder', animation: 'colorYORP 8s linear infinite' }}>Join</p>
        </Link>
      </div>
    </section>
  )
}